import React from 'react'
import PropTypes from 'prop-types'
import './PlaylistTile.scss'
import Playlist from '../../models/Playlist'

const PlaylistTile = ({ playlist, fromAngular }) => {
  if (fromAngular) {
    playlist = new Playlist(playlist)
  }

  return (
    <div className='PlaylistTile'>
      <a
        className='PlaylistTile__image'
        href={`${playlist.url()}?source=playlists`}
      >
        <img src={playlist.imageUrl()} />
      </a>
      <h1 className='PlaylistTile__title'>
        <a href={playlist.url()}>{playlist.title}</a>
      </h1>
    </div>
  )
}

PlaylistTile.defaultProps = {
  fromAngular: false
}

PlaylistTile.propTypes = {
  playlist: PropTypes.object,
  fromAngular: PropTypes.bool // Temporary hack to bridge angular and react.
}

export default PlaylistTile
